<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col class="p-0">
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1742460341/2025/Footer/ground-mobile.png"
            fluid
            class="d-block d-sm-none"
            style="margin-bottom: -1px"
            alt=""
            aria-hidden="true"
          >
          </b-img>
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1742460341/2025/Footer/ground_footer.png"
            fluid
            class="d-none d-sm-block"
            style="margin-bottom: -2px"
            alt=""
            aria-hidden="true"
          >
          </b-img>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="bg-dark-brown">
      <Sponsors />
      <b-row>
        <b-col class="p-0 overflow-hidden">
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1742460344/2025/Footer/stars-footer.png"
            fluid
            style="width: 100%; margin-bottom: -35vw; margin-top: -4vw"
            class="d-none d-md-block"
            alt=""
            aria-hidden="true"
          />
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1742477963/2025/Footer/stars_footer.png"
            fluid
            style="width: 100%; margin-top: -4vw; margin-bottom: -15vw"
            class="d-md-none"
            alt=""
            aria-hidden="true"
          />
        </b-col>
      </b-row>
      <b-row style="margin-bottom: -1vw">
        <b-col class="p-0">
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1742460341/2025/Footer/moon_footer.png"
            fluid
            style="width: 100%"
            class="d-none d-md-block"
            alt=""
            aria-hidden="true"
          />
          <b-img
            src="https://res.cloudinary.com/oredev/image/upload/v1742477959/2025/Footer/moon_footer_mobile.png"
            fluid
            style="width: 100%"
            class="d-md-none"
            alt=""
            aria-hidden="true"
          />
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="bg-beige pt-5 pb-5">
      <footer class="mb-5">
        <b-container style="max-width: 904px">
          <b-row class="mb-4">
            <b-col>
              <h2>
                ØREDEV DEVELOPERS CONFERENCE<br
                  class="d-none d-sm-block d-lg-none"
                  aria-hidden="true"
                />
                <span style="white-space: nowrap">5-7th</span> NOV 2025
              </h2>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <b-row>
                <b-col>
                  <p class="newsletter-header">Join our newsletter!</p>
                </b-col>
              </b-row>
              <form
                action="https://oredev.us8.list-manage.com/subscribe/post?u=58a8d04056a9694a44fdbabf6&amp;id=d4cb377f54&amp;f_id=001806e0f0"
                method="post"
                target="_blank"
              >
                <b-row class="mb-3 mb-md-0">
                  <b-col
                    cols="12"
                    lg="3"
                    class="mb-2 mb-xl-0"
                    style="margin-right: -40px"
                  >
                    <p class="m-0" style="padding-top: 9px">Your email</p>
                  </b-col>
                  <b-col
                    cols="12"
                    sm="8"
                    lg="7"
                    class="pl-lg-0 mb-3 mb-sm-0"
                    style="margin-right: -20px"
                  >
                    <input
                      placeholder="enter email..."
                      aria-label="enter email..."
                      value=""
                      type="email"
                      name="EMAIL"
                      class="email"
                      style="width: 100%"
                    />
                  </b-col>
                  <b-col cols="12" sm="4" lg="2">
                    <button type="submit" class="btn btn-lime-green">
                      Submit
                    </button>
                  </b-col>
                </b-row>
              </form>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              md="7"
              class="order-2 order-md-1 d-flex flex-column justify-content-end"
            >
              <FooterLinks />
            </b-col>
            <b-col md="5" class="social-media order-1 order-md-2 mb-4 mb-md-0">
              <div class="float-md-right">
                <p>
                  Keep in touch<br />
                  Email:
                  <a href="mailto:info@oredev.org">info@oredev.org</a>
                  <br />
                  Öredev AB
                </p>
                <SocialMedia />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </footer>
    </b-container>
  </div>
</template>

<script>
import Sponsors from "@/components/Footer/Sponsors.vue";
import FooterLinks from "@/components/Footer/FooterLinks.vue";
import SocialMedia from "@/components/Footer/SocialMedia.vue";

export default {
  components: { Sponsors, FooterLinks, SocialMedia },
  name: "Footer",
};
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

footer {
  .newsletter-header {
    font-weight: 700;
    font-size: 24px;
    letter-spacing: 0.05rem;
    @media (max-width: 767px) {
      font-size: 20px;
    }
  }
  .email {
    height: 42px;
    padding-left: 5px;
    border-radius: 8px;
    border: 2px solid $dark-brown;
    outline: none;
  }
  .social-media {
    font-size: 14px;
    @media (min-width: 576px) {
      font-size: 17px;
      line-height: 33px;
    }
    p {
      margin-bottom: 8px;
    }
    a {
      color: $dark-brown !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue